import React, { useRef, useEffect, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import { Button, Dialog, InputAdornment, TextField } from "@mui/material";
import { ReactComponent as Refresh } from "../../../Assets/img/Kyc/svg/refresh.svg";
import "../../../Assets/css/kyc.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";

const VerifyNricForm = () => {
  const location = useLocation();
  const { documentType } = location.state || {};
  const numOfContainers = 6;
  //   const [documentType, setDocumentType] = useState("");
  const [nricNumber, setNricNumber] = useState("");
  const [open, setOpen] = useState(false);
  const canvasRef = useRef(null); // Create a ref for the canvas
  const [currentCaptcha, setCurrentCaptcha] = useState(""); // Store current CAPTCHA
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const [masking, setMasking] = useState("");
  const [captcha, setCaptcha] = useState("");
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [verify, setVerify] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Set dragging state
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files; // Access dropped files
    handleFileChange({ target: { files } }); // Pass files to the handler
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Only handle one file
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Set the image preview to the FileReader result
      };
      reader.readAsDataURL(file);
      console.log("Image preview", imagePreview);
      // Read the file as a data URL for preview
    } else {
      console.log("Please upload a valid image file.");
    }
  };
  // Create an array of refs for OTP fields

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input when the component mounts
    }
  }, []);

  const maskingFunction = (number) => {
    if (number <= 4) {
      return number;
    }
    return number.slice(-3).padStart(number.length, "*");
  };
  const handleMasking = (e) => {
    const input = e.target.value;
    setNricNumber(input);

    const masking = maskingFunction(input);
    setMasking(masking);
  };
  const documentLabels = {
    10: "Pink NRIC (Citizen)",
    20: "Orange NRIC (PR)",
    30: "Blue NRIC (EP)",
  };
  const generateCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captchaText = "";

    for (let i = 0; i < 6; i++) {
      const randomChar = characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
      captchaText += randomChar;
    }

    // Ensure the canvas element exists before accessing it
    const canvas = canvasRef.current;
    if (!canvas) {
      return captchaText;
    }

    const ctx = canvas.getContext("2d");

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Set styles for the CAPTCHA text
    ctx.font = "24px Arial";
    ctx.fillStyle = "rgb(0, 0, 0)";
    ctx.textBaseline = "middle";
    ctx.fillText(captchaText, 10, canvas.height / 2);

    return captchaText;
  };

  useEffect(() => {
    // Generate CAPTCHA when component mounts
    setCurrentCaptcha(generateCaptcha());

    const refreshCaptchaButton = document.getElementById("refreshCaptcha");
    refreshCaptchaButton.addEventListener("click", () => {
      setCurrentCaptcha(generateCaptcha());
    });

    return () => {
      // Clean up the event listener on unmount
      refreshCaptchaButton.removeEventListener("click", () => {
        setCurrentCaptcha(generateCaptcha());
      });
    };
  }, []); // Empty dependency array means this runs once when the component mounts

  const verifyCaptcha = () => {
    const input = document.getElementById("captchaInput").value;
    const messageElement = document.getElementById("captchaMessage");

    if (input === currentCaptcha) {
      messageElement.textContent = "CAPTCHA verified successfully!";
      messageElement.style.color = "green";
      return true; // Return true if CAPTCHA is verified
    } else {
      messageElement.textContent = "Incorrect CAPTCHA. Please try again.";
      messageElement.style.color = "red";
      return false; // Return false if CAPTCHA is not correct
    }
  };

  const inputRefs = useRef([]); // Create an array of refs for each text field

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
  };

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");

  return (
    <>
      <div className="Allcards_full_container p-3">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your NRIC Identity</h2>
            {showData ? (
              <p className="paragraph m-0">
                Upload Your NRIC Card for Secure Verification.
              </p>
            ) : (
              <p className="paragraph m-0">
                Your NRIC has been Verified Successfully.
              </p>
            )}

            <TextField
              label="NRIC Card Type*"
              value={documentLabels[documentType] || ""}
              className="m-2"
              style={{ width: "400px" }}
              InputProps={{
                readOnly: true, // Make the TextField read-only
              }}
            />
            <div className="d-flex justify-content-center">
              <div>
                {!fileURL && (
                  <>
                    {imagePreview ? (
                      ""
                    ) : (
                      <>
                        <div
                          //   className={`file-upload-container ${
                          //     isDragging ? "dragging" : ""
                          //   }`}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            id="file-input"
                          />

                          <label
                            htmlFor="file-input"
                            className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3"
                          >
                            <Cloud width={80} />
                            <span className="m-0 p-0">
                              {isDragging
                                ? "Drop file here"
                                : "Drag file here or "}
                              <span className="text-primary">Upload File</span>
                            </span>
                            <p>5MB max file size</p>
                          </label>
                        </div>
                      </>
                    )}

                    {imagePreview && (
                      <div className="selectedImage">
                        <img
                          src={imagePreview}
                          alt="Uploaded"
                          style={{ maxWidth: "300px", marginTop: "20px" }}
                        />
                      </div>
                    )}
                  </>
                )}

                {fileURL && (
                  <div className="selectedImage">
                    {file && file.type.startsWith("image/") && (
                      <img
                        src={fileURL}
                        alt="Selected"
                        style={{
                          marginTop: "10px",
                          // maxWidth: "300px",
                          // maxHeight: "300px",
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                    {file && file.type === "application/pdf" && (
                      <iframe
                        src={fileURL}
                        title="Selected PDF"
                        style={{
                          marginTop: "10px",
                          width: "100%",
                          height: "500px",
                        }}
                      />
                    )}
                  </div>
                )}
                {file && file.type === "application/pdf" && (
                  <iframe
                    src={fileURL}
                    title="Selected PDF"
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      height: "500px",
                    }}
                  />
                )}
              </div>
              {!imagePreview && (
                <>
                  <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                    <Takephoto />
                    <p className="custom-text-color text-capitalize">
                      Capture Image
                    </p>
                  </Button>
                </>
              )}
            </div>

            {showData ? (
              <p className="paragraph ">
                After you upload your Aadhaar card, the Aadhaar number will be
                automatically detected <br />
                and displayed here. Alternatively, you can manually enter the
                Aadhaar number below.
              </p>
            ) : (
              ""
            )}

            {!showData && (
              <div className="d-flex flex-row align-items-center">
                <TextField
                  value={masking}
                  onChange={(e) => setMasking(e.target.value)}
                  label={"NRIC Number*"}
                  className="m-2"
                  style={{ width: "400px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {verify ? <Verify /> : <NonVerify />}
                      </InputAdornment>
                    ),
                  }}
                />
                {/* <div className="verify d-flex align-items-center">
              {verify ? <Verify /> : <NonVerify />}
            </div> */}
                <br />
              </div>
            )}

            {!showData ? (
              <p className="paragraph">
                Thank you for verifying your Aadhar number. Your identity has
                been securely confirmed. You can now proceed to
                <br />
                the next steps or return to your dashboard to explore other
                features.
              </p>
            ) : (
              ""
            )}

            {showData ? (
              <>
                <div className="caption-text">
                  <div className="textbox-container">
                    <TextField
                      value={nricNumber}
                      onChange={handleMasking}
                      label={"NRIC Number*"}
                      className="m-2"
                      style={{ width: "400px" }}
                    />
                    <TextField
                      value={captcha}
                      className="m-2"
                      onChange={(e) => setCaptcha(e.target.value)}
                      label={"Enter the Captcha here*"}
                      style={{ width: "400px" }}
                      id="captchaInput"
                    />
                  </div>

                  <div className="captcha-container">
                    <canvas
                      className="captchaCanvas"
                      ref={canvasRef}
                      width="150"
                      height="50"
                    ></canvas>
                    <button id="refreshCaptcha">
                      <Refresh />
                    </button>
                  </div>
                  <p id="captchaMessage"></p>
                </div>
              </>
            ) : (
              ""
            )}

            {showData ? (
              <Button
                className="btncolor w-30px"
                variant="contained"
                onClick={() => {
                  if (verifyCaptcha()) {
                    setOpen(true); // Open the OTP dialog if CAPTCHA is correct
                  }
                }}
              >
                Send OTP
              </Button>
            ) : (
              <Button
                className="btncolor"
                variant="contained"
                onClick={() =>
                  navigate("/countrySelecting", {
                    state: {
                      SelectedCountry: {
                        label: "Singpore",
                        code: "SG",
                        phone: "65",
                      },
                    }, // Pass the selected country object
                  })
                }
              >
                Back to KYC
              </Button>
            )}

            {/* OTP Dialog */}
            <Dialog open={open} onClose={() => setOpen(false)}>
              <div className="m-4">
                <div
                  className="d-flex flex-row justify-content-between align-items-center"
                  sx={{ margin: 2, padding: 0 }}
                >
                  <div>
                    <h6 className="m-0 p-0 fw-bold">Enter Your OTP</h6>
                  </div>
                  <div>
                    {/* <Close onClick={() => setOpen(false)} /> */}
                    <CloseRoundedIcon onClick={() => setOpen(false)} />
                  </div>
                </div>
                <div>
                  <p className="m-0 p-0 ">
                    Verify Your NRIC with the One-Time Password
                  </p>
                  <div className="d-flex flex-row m-5">
                    {Array.from({ length: numOfContainers }, (_, index) => (
                      <TextField
                        key={index}
                        inputRef={(el) => (inputRefs.current[index] = el)} // Assign ref to each text field
                        variant="standard"
                        style={{
                          margin: "10px",
                          width: "40px",
                          textAlign: "center",
                        }}
                        inputProps={{
                          maxLength: 1, // Only allow one character
                          style: { textAlign: "center" }, // Center text
                        }}
                        onChange={(e) => handleInputChange(e, index)} // Handle input change
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="m-2 d-flex justify-content-center align-items-center">
                <Button
                  variant="contained"
                  className="btncolor"
                  onClick={() => {
                    setVerifiedOpen(true);
                    setOpen(false);
                  }}
                >
                  Verify
                </Button>
              </div>
            </Dialog>

            {/* Success Dialog */}
            <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
              <div className="m-4 p-2 align-items-center justify-content-center text-center">
                <Successmsg />
                <div className="align-items-center justify-content-center text-center">
                  <h6 className="fw-bold">Verification Successful!</h6>
                  <p>Your NRIC has been successfully verified.</p>
                </div>
              </div>
              <div className="d-flex justify-content-center m-3">
                <Button
                  variant="contained"
                  className="btncolor"
                  onClick={() => handleClose()}
                >
                  Continue
                </Button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyNricForm;
